import 'babel-polyfill';

import { resizeIframe } from './utils/iframe';

window.apps = {
    resizeIframe,
};



// WEBPACK FOOTER //
// ./assets/index.js